import React, { useContext, memo } from "react";
import {
  Polygon,
  Polyline
} from "@react-google-maps/api";
import { WebMapContext } from "../WebMapGoogleMap";

const GeoAreaSection = ({
  eyeIcons,
  focusedPolygon
}) => {
  const {
    appliedFilters,
  } = useContext(WebMapContext);

  return (
    eyeIcons.adminLevel &&
      appliedFilters.year &&
      appliedFilters.quarter
      ? focusedPolygon?.map((data, index) => {
        return <Polygon
          path={data}
          key={index}
          options={{
            fillColor: "white",
            fillOpacity: 0,
            strokeColor: data.length !== 4 ? "red" : "grey",
            strokeOpacity: 0.8,
            strokeWeight: 1,
            clickable: false,
            draggable: false,
            editable: false,
            geodesic: false,
            zIndex: 1,
          }}
        />
      })
      : <></>
  )
};

export default memo(GeoAreaSection);